export function getColumnWidthStyle({ width, minWidth }) {
  const styleSheets = {};
  if (width) {
    styleSheets.width = `${width}px`;
  } else if (minWidth) {
    styleSheets.minWidth = `${minWidth}px`;
  } else {
    styleSheets.flex = 1;
  }

  return styleSheets;
}

export function getColumnClasses({ column: { align } = {}, columnIndex }) {
  const classes = [`gt-table__column-${columnIndex + 1}`];

  if (align) classes.push(align);

  if (columnIndex === 0) classes.push("is-first");

  return classes;
}

export function isFunction(fn) {
  return Object.prototype.toString.call(fn) === "[object Function]";
}
